module.exports = __webpack_public_path__ + "static/img/dd-personal-qrcode.84f05ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-personal-qrcode.png
// module id = Fgjt
// module chunks = 1